'use client'

import { createContext, useContext } from 'react'
import { useMachine } from '@xstate/react'
import { uiMachine } from './uiMachine'

export type UIMachineApi = ReturnType<typeof useMachine<typeof uiMachine>>

const UIMachineContext = createContext<UIMachineApi | null>(null)

export function UIMachineProvider({ children }: { children: React.ReactNode }) {
  const machineApi = useMachine(uiMachine)
  return <UIMachineContext.Provider value={machineApi}>{children}</UIMachineContext.Provider>
}

export function useUIMachine() {
  const ctx = useContext(UIMachineContext)
  if (!ctx) {
    throw new Error('useUIMachine must be used within UIMachineProvider')
  }
  return ctx
}
